<template>
    <div>
        <div v-if="initilizingCart">
            <blurryLoader />
        </div>
        <div v-if="submitted" class="loading-overlay2">
            <div class="">
                <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                    <circle cx="50" cy="50" fill="none" stroke="#2e9bf0" stroke-width="10" r="35" stroke-dasharray="165 57">
                        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                    </circle>
                </svg>
            </div>
        </div>
        <div class="error_popup popup-desktop" v-if="addressError" style="display:block; z-index: 9999; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5);">
            <div class="error_box error-pop-desk">
                <img src="@/assets/images/icon_Urgent.svg" loading="lazy" alt="" class="image-496">
                <div class="text-block-1101">Invalid Address</div>
                <div class="text-block-1102">FedEx and UPS our carriers do not deliver to P.O. Box addresses. Please enter a valid street address.</div>
                <div class="text-block-1102">
                    <a href="#" @click.prevent="addressError=false;" class="submit-button-3 new w-button"  style="color:#fff;margin-top: 0px;margin-bottom: 0px;">Update Address</a>
                </div>
            </div>
        </div>
        <div class="error_popup popup-desktop" v-if="cartError" style="display:block; z-index: 9999; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5);">
            <div class="error_box error-pop-desk">
                <img src="@/assets/images/icon_Urgent.svg" loading="lazy" alt="" class="image-496">
                <div class="text-block-1101">Cart Not Found</div>
                <div class="text-block-1102">No cart items found. Either the user has completed checkout or the cart doesn't exist. Please check your link.</div>
                <div class="text-block-1102">
                    <a href="/home" class="submit-button-3 new w-button" style="color:#fff;margin-top: 0px;margin-bottom: 0px;">Go to Home</a>
                </div>
            </div>
        </div>
        <section class="section_semaco-top">
            <div class="semaco-top-wrap">
                <div class="semaco_topdiv">
                    <a href="#" class="w-inline-block"><img sizes="(max-width: 479px) 67.2265625px, 84.03125px" srcset="@/assets/images/Logo-p-500.png 500w, @/assets/images/Logo-p-800.png 800w, @/assets/images/Main_Logo.png 1000w" alt="" src="@/assets/images/Main_Logo.png" loading="lazy" class="image-31" :class="{'image-31-desk' : !isMobile}"></a>
                </div>
            </div>
        </section>
        <div class="section_semaglutidecheckout" v-if="!cartError">

            <div class="semaco_wrap" v-if="!isMobile">
                <div class="semaco_div">
                    <div class="semaco_payinfo">
                        <div class="step-4">
                            <div class="div-block-1291">
                                <h1 class="heading-8 _1 b checkout">Everything included. One low monthly price.</h1>
                                <div class="text-block-250 checkout">No Membership Fees. No Upcharging for Higher Dosage.</div>
                            </div>
                            <div class="w-form">
                                <form class="step-2-left-payment-form new-checkout new-mobile checkout-desk" @submit.prevent="getStripeToken()">
                                    <a href="#" class="link-block-13 w-inline-block"></a>
                                    
                                    <div class="div-block-1292">
                                        <div class="div-block-853 new">
                                            <div class="text-block-80"><strong>Credit Card</strong></div>
                                            <img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd36103790_visa.png" class="image-471">
                                            <img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd36103780_mastercard.png" class="image-471">
                                            <img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd36103794_AmEx.png" class="image-471">
                                            <img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd3610377e_discover.png" class="image-471">
                                        </div>
                                        <div>
                                            <label for="email" class="field-label-4 new">Card Number</label>
                                            <div id="card-element" class="ns-card-element" ref="myElement"></div>
                                        </div>
                                        <label for="email" class="field-label-4">Shipping Address</label>
                                        <google-places-autocomplete :api-key="googleMapsApiKey" @address-updated="getAddressData" />
                                        <label for="email" class="field-label-4">
                                            <input type="checkbox" @change="differentShipping = !differentShipping">
                                            Different Billing Address?
                                        </label>
                                        <div v-if="differentShipping">
                                            <label for="email" class="field-label-4">Billing Address</label>
                                            <google-places-autocomplete :api-key="googleMapsApiKey" @address-updated="getAddressDataBilling" />
                                        </div>
                                        
                                        <button class="submit-button-3 new w-button" :disabled="submitted" style="color:#fff">
                                            <span v-if="submitted"><img src="@/assets/images/submitted.svg"></span>
                                            <span v-else>Buy Now and Save</span>
                                        </button>
                                        <div class="w-form-fail" style="display:block" v-if="paymentError">
                                            <div>{{errorMessage}}</div>
                                        </div>
                                    </div>
                                    <div class="div-block-1154 div-block-1154-centered">
                                        <input type="hidden" name="xxTrustedFormCertUrl" id="xxTrustedFormCertUrl_0" ref="trustedFormUrl" value="">
                                        <div class="text-block-252">
                                            By clicking "Buy Now and Save" or checking out with Apple or Google Pay you agree to enroll in a 
                                            {{ paymentTermLabels[paymentInfo.payment_terms].duration }}
                                            program billed 
                                            {{ paymentTermLabels[paymentInfo.payment_terms].billingFrequency }}
                                            , with automatic renewal and charges until canceled. You authorize recurring payments and confirm that you have read and agree to the <a :href="`${appMainWeb}/returns`" target="_blank">Refund Policy</a>, <a :href="`${appMainWeb}/terms`" target="_blank">Terms and Conditions</a>, <a :href="`${appMainWeb}/terms`" target="_blank">Terms of Use</a>, <a :href="`${appMainWeb}/privacy`" target="_blank">Privacy Policy</a>, <a :href="`${appMainWeb}/hipaa`" target="_blank">HIPAA Notice</a>, and <a :href="`${appMainWeb}/telehealth-consent`" target="_blank">Telehealth Consent</a>, and are at least 18 years of age.
                                        </div>
                                    </div>
                                </form>
                                <div class="w-form-done">
                                    <div>Thank you! Your submission has been received!</div>
                                </div>
                                <div class="w-form-fail">
                                    <div>Oops! Something went wrong while submitting the form.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="semaco_orderdetails">
                        <div class="plan-select-div">
                            <div class="select-plan-text">Select Your Plan</div>
                            <div class="text-block-1300"><strong>Click Below to Choose, </strong><span class="text-block-1300">How You’d Like to Pay</span></div>
                            <div class="plan-choices-div">
                                <div class="plans-div">
                                    <div class="sema-plan-div">
                                        <a href="#" class="plan-link quart w-inline-block" :class="{'planactive' : paymentInfo.payment_terms==3}" @click.prevent="paymentInfo.payment_terms=3">
                                            <div class="plan-type-text">3 Month Plan</div>
                                            <div class="plan-price">${{getMonthlyPrice(3).toFixed(2)}} a Month</div>
                                            <div class="plan-price">${{getTotalPrice(3).toFixed(2)}} Total 3 Months</div>
                                            <div class="plan-price"><strong>{{getSavingsText(3)}}</strong></div>
                                        </a>
                                    </div>
                                    <div class="sema-plan-div">
                                        <a href="#" class="plan-link monthly w-inline-block" :class="{'planactive' : paymentInfo.payment_terms==1}" @click.prevent="paymentInfo.payment_terms=1">
                                            <div class="plan-type-text">Monthly Plan</div>
                                            <div class="plan-price">${{getFirstMonthPrice().toFixed(2)}} / month</div>
                                            <div class="plan-price">${{getRegularMonthlyPrice().toFixed(2)}} Thereafter</div>
                                            <div class="plan-price"><strong>Industry Low Pricing</strong></div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="plan-choices-div _6month" style="border-color: #dfdfdf; border-width: 2px;">
                                <div class="plans-div">
                                    <div class="sema-plan-div" style="width: 100%;">
                                        <a href="#" class="plan-link quart w-inline-block"  :class="{'planactive' : paymentInfo.payment_terms==6}" @click.prevent="paymentInfo.payment_terms=6">
                                            <div class="plan-type-text">6 Months Plan</div>
                                            <div class="plan-price">${{getMonthlyPrice(6).toFixed(2)}} a Month</div>
                                            <div class="plan-price">${{getTotalPrice(6).toFixed(2)}} Total 6 Months</div>
                                            <div class="plan-price"><strong>{{getSavingsText(6)}}</strong></div>
                                            <div class="plan-price">3 month Supply today & 3 more in 90 Days.</div>
                                            
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <p style="text-align: center;justify-content: center; color: red;font-size: 16px; font-weight: bold; font-family: Mulish, sans-serif;">Lock In a 12 Month Prescription Today<br/>So You Don't Run Out!</p>
                            <div class="plan-choices-div _6month" style="border-color: #ff4c46;">
                                
                                <div class="plans-div">
                                    <div class="sema-plan-div" style="width: 100%;">
                                        <a href="#" class="plan-link quart w-inline-block"  :class="{'planactive' : paymentInfo.payment_terms==12}" @click.prevent="paymentInfo.payment_terms=12">
                                            <div class="plan-type-text">12 Months Plan</div>
                                            <div class="plan-price">${{getMonthlyPrice(12).toFixed(2)}} a Month</div>
                                            <div class="plan-price">${{getTotalPrice(12).toFixed(2)}} Total 12 Months</div>
                                            <div class="plan-price"><strong>{{getSavingsText(12)}}</strong></div>
                                            <div class="plan-price">3 month supply every 90 days for a year</div>
                                            
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="summary-desk">
                            <div class="monthly-order" style="display:block;">
                                <div class="div-block-960 new">
                                    <div class="div-block-976">
                                        <div class="div-block-974">
                                            <div class="checkout-product-div"><img :src="getImage" loading="lazy" sizes="100vw" :srcset="`${getImage} 500w, ${getImage} 800w, ${getImage} 1080w`" alt=""></div>
                                            <div class="div-block-975" style="background-color: transparent;">
                                                <div class="text-block-161" style="color: #fff;"></div>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="product-name-2">{{getcartItems.name}}</div>
                                            <div class="text-block-850" v-if="getcartItems.name==='Tirzepatide'">Compounded with B6 (Pyridoxine)</div>
                                            <div class="text-block-850" v-else>Compounded with B12 (Cyanocobalamin)</div>
                                            <div class="text-block-850" v-if="paymentInfo.payment_terms===12">3 month supply every 90 days for a year.</div>
                                            <div class="text-block-850" v-else-if="paymentInfo.payment_terms===6">3 month Supply today & 3 more in 90 Days.</div>
                                            <div class="text-block-850" v-else>3 Months Supply.</div>
                                            <!--<div class="text-block-850" style="font-size: 12px;cursor: pointer;margin-top:10px" @click="changeItem(getcartItems.name)"><strong>Made a mistake? Click to change meds.</strong></div>-->
                                        </div>
                                    </div>
                                    <div class="div-block-1778">
                                        <div class="item-price-text">${{(getCurrentPrice() - parseInt(paymentInfo.discount)).toFixed(2)}}</div>
                                        <div class="text-block-849">{{paymentTermLabels[paymentInfo.payment_terms].billingLabel}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="plan-inclusions-div">
                                <div class="inclusion-div">
                                    <div class="inclusion-left"><img src="@/assets/images/icon_PM_No_Increase_blk.png" loading="lazy" alt="" class="image-473">
                                        <div class="inclusion-text">All Dosages Same Price.</div>
                                    </div>
                                    <div class="text-block-1035">FREE</div>
                                </div>
                                <div class="inclusion-div">
                                    <div class="inclusion-left"><img src="@/assets/images/icon_board-copy.svg" loading="lazy" alt="" class="image-473">
                                        <div class="inclusion-text">Telehealth Visit<sup>*</sup></div>
                                    </div>
                                    <div class="text-block-1035">FREE</div>
                                </div>
                                <div class="inclusion-div">
                                    <div class="inclusion-left"><img src="@/assets/images/icon_support.svg" loading="lazy" alt="" class="image-473">
                                        <div class="inclusion-text">Unlimited Clinical Chat<sup>*</sup></div>
                                    </div>
                                    <div class="text-block-1035">FREE</div>
                                </div>
                                <div class="inclusion-div">
                                    <div class="inclusion-left"><img src="@/assets/images/icon_delivery.svg" loading="lazy" alt="" class="image-473">
                                        <div class="inclusion-text">Overnight Cold Shipping</div>
                                    </div>
                                    <div class="text-block-1035">FREE</div>
                                </div>
                            </div>
                            <div class="quarterly-details-div" style="padding-top:5px">
                                <p style="font-size: 8px;line-height: normal; padding-bottom:15px">*The clinician consultation fee is included in the program cost and is paid directly to our independent doctor network partners. This fee is processed regardless of whether you qualify for treatment or receive a prescription. If your consultation results in a denial, you will not be responsible for this payment.</p>
                                <div class="quart-deet-header-div">
                                    <div class="text-block-1036">{{paymentTermLabels[paymentInfo.payment_terms].planName}}:</div>
                                    <div class="div-block-1903" style="background: #00A36C;">
                                        <div class="text-block-1037" style="color:#fff" v-if="paymentInfo.payment_terms==3">Big Savings</div>
                                        <div class="text-block-1037" style="color:#fff" v-else-if="paymentInfo.payment_terms==6">Huge Savings</div>
                                        <div class="text-block-1037" style="color:#fff" v-else-if="paymentInfo.payment_terms==12">Best Price</div>
                                        <div class="text-block-1037" style="color:#fff" v-else>${{getMonthlyDiscount().toFixed(0)}} Off Your 1st Month!</div>
                                    </div>
                                </div>
                                <ul role="list" class="list-5">
                                    <li class="list-item-4" v-for="(point, index) in getPlanPoints" :key="`point-plan${index}`">
                                        <div class="text-block-1038">{{point.header}}</div>
                                        <div class="text-block-1039">{{point.sub_header}}</div>
                                    </li>
                                </ul>
                            </div>
                            <div class="couponcodediv _1 coupon new">
                                <div class="form-block-15 w-form">
                                    <form>
                                        <div class="div-block-1897 checkout">
                                            <input class="text-field-55 coupon new w-input" maxlength="256" v-model="couponInput" name="field-3" data-name="Field 3" placeholder="Coupon Code" type="text" id="field-3" required>
                                            <a href="#" class="button-103 new w-button" style="color:#fff" @click.prevent="handleCouponSubmit()">Apply</a>
                                        </div>
                                        <div class="w-form-fail" style="display: block;" v-if="couponError">
                                            <div>Invalid Coupon.</div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div class="text-block-90">Monthly Access. <span class="text-span-13">Cancel anytime. </span></div>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- Mobile version - structure is the same but with mobile-specific classes -->
            <div class="sema-checkout-mobile" v-else>
                <div class="semaco_orderdetails">
                    <div class="plan-select-div">
                        <div class="select-plan-text">Select Your Plan</div>
                        <div class="text-block-1300"><strong>Click Below to Choose, </strong><span class="text-block-1300">How You’d Like to Pay</span></div>
                        <div class="plan-choices-div">
                            <div class="plans-div">
                                <div class="sema-plan-div">
                                    <a href="#" class="plan-link quart w-inline-block" :class="{'planactive' : paymentInfo.payment_terms==3}" @click.prevent="paymentInfo.payment_terms=3">
                                        <div class="plan-type-text">3 Month Plan</div>
                                        <div class="plan-price">${{getMonthlyPrice(3).toFixed(2)}} a Month</div>
                                        <div class="plan-price">${{getTotalPrice(3).toFixed(2)}} Total 3 Months</div>
                                        <div class="plan-price"><strong>{{getSavingsText(3)}}</strong></div>
                                    </a>
                                </div>
                                <div class="sema-plan-div">
                                    <a href="#" class="plan-link monthly w-inline-block" :class="{'planactive' : paymentInfo.payment_terms==1}" @click.prevent="paymentInfo.payment_terms=1">
                                        <div class="plan-type-text">Monthly Plan</div>
                                        <div class="plan-price">${{getFirstMonthPrice().toFixed(2)}} / month</div>
                                        <div class="plan-price">${{getRegularMonthlyPrice().toFixed(2)}} Thereafter</div>
                                        <div class="plan-price"><strong>Industry Low Pricing</strong></div>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="plan-choices-div _6month" style="border-color: #dfdfdf; border-width: 2px;">
                            <div class="plans-div">
                                <div class="sema-plan-div" style="width:100%">
                                    <a href="#" class="plan-link quart w-inline-block" :class="{'planactive' : paymentInfo.payment_terms==6}" @click.prevent="paymentInfo.payment_terms=6">
                                        <div class="plan-type-text">6 Months Plan</div>
                                        <div class="plan-price">${{getMonthlyPrice(6).toFixed(2)}} a Month</div>
                                        <div class="plan-price">${{getTotalPrice(6).toFixed(2)}} Total 6 Months</div>
                                        <div class="plan-price"><strong>{{getSavingsText(6)}}</strong></div>
                                        <div class="plan-price">3 month Supply today & 3 more in 90 Days.</div>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <p style="text-align: center;justify-content: center; color: red;font-size: 16px; font-weight: bold; font-family: Mulish, sans-serif;">Lock In a 12 Month Prescription Today<br/>So You Don't Run Out!</p>
                            <div class="plan-choices-div _6month" style="border-color: #ff4c46;">
                           
                            <div class="plans-div">
                                <div class="sema-plan-div" style="width:100%">
                                    <a href="#" class="plan-link quart w-inline-block" :class="{'planactive' : paymentInfo.payment_terms==12}" @click.prevent="paymentInfo.payment_terms=12">
                                        <div class="plan-type-text">12 Months Plan</div>
                                        <div class="plan-price">${{getMonthlyPrice(12).toFixed(2)}} a Month</div>
                                        <div class="plan-price">${{getTotalPrice(12).toFixed(2)}} Total 12 Months</div>
                                        <div class="plan-price"><strong>{{getSavingsText(12)}}</strong></div>
                                         <div class="plan-price">3 month supply every 90 days for a year</div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="summary-desk">
                        <div class="quartely-order">
                            <div class="div-block-960 new">
                                <div class="div-block-976">
                                    <div class="div-block-974">
                                        <div class="checkout-product-div"><img :src="getImage" loading="lazy" sizes="100vw" :srcset="`${getImage} 500w, ${getImage} 800w, ${getImage} 1080w`" alt=""></div>
                                        <div class="div-block-975" style="background-color: transparent;">
                                            <div class="text-block-161" style="color: #fff;"></div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="product-name-2">{{getcartItems.name}}</div>
                                        <div class="text-block-850" v-if="getcartItems.name==='Tirzepatide'">Compounded with B6 (Pyridoxine)</div>
                                        <div class="text-block-850" v-else>Compounded with B12 (Cyanocobalamin)</div>
                                        <div class="text-block-850" v-if="paymentInfo.payment_terms===12">3 month supply every 90 days for a year.</div>
                                        <div class="text-block-850" v-else-if="paymentInfo.payment_terms===6">3 month Supply today & 3 more in 90 Days.</div>
                                        <div class="text-block-850" v-else>3 Months Supply.</div>
                                        <!--<div class="text-block-850" style="font-size: 12px;cursor: pointer;margin-top:10px" @click="changeItem(getcartItems.name)"><strong>Made a mistake? Click to change meds.</strong></div>-->
                                    </div>
                                </div>
                                <div class="div-block-1778">
                                    <div class="item-price-text">${{(getCurrentPrice() - parseInt(paymentInfo.discount)).toFixed(2)}}</div>
                                    <div class="text-block-849">{{paymentTermLabels[paymentInfo.payment_terms].billingLabel}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="monthly-order">
                            <div class="div-block-960 new">
                                <div class="div-block-976">
                                    <div class="div-block-974">
                                        <div class="checkout-product-div"><img :src="getImage" loading="lazy" sizes="100vw" :srcset="`${getImage} 500w, ${getImage} 800w, ${getImage} 1080w`" alt=""></div>
                                        <div class="div-block-975" style="background-color: transparent;">
                                            <div class="text-block-161" style="color: #fff;"></div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="product-name-2">{{getcartItems.name}}<br></div>
                                        <div class="text-block-850">{{getSupplyDuration}} Supply</div>
                                    </div>
                                </div>
    
                                <div class="div-block-1778">
                                    <div class="item-price-text">${{getCurrentPrice()}}</div>
                                    <div class="text-block-849">{{paymentTermLabels[paymentInfo.payment_terms].billingLabel}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="plan-inclusions-div">
                            <div class="inclusion-div">
                                <div class="inclusion-left"><img src="@/assets/images/icon_PM_No_Increase_blk.png" loading="lazy" alt="" class="image-473">
                                    <div class="inclusion-text">All Dosages Same Price.</div>
                                </div>
                                <div class="text-block-1035">FREE</div>
                            </div>
                            <div class="inclusion-div">
                                <div class="inclusion-left"><img src="@/assets/images/icon_board-copy.svg" loading="lazy" alt="" class="image-473">
                                    <div class="inclusion-text">Telehealth Visit<sup>*</sup></div>
                                </div>
                                <div class="text-block-1035">FREE</div>
                            </div>
                            <div class="inclusion-div">
                                <div class="inclusion-left"><img src="@/assets/images/icon_support.svg" loading="lazy" alt="" class="image-473">
                                    <div class="inclusion-text">Unlimited Clinical Chat<sup>*</sup></div>
                                </div>
                                <div class="text-block-1035">FREE</div>
                            </div>
                            <div class="inclusion-div">
                                <div class="inclusion-left"><img src="@/assets/images/icon_delivery.svg" loading="lazy" alt="" class="image-473">
                                    <div class="inclusion-text">Overnight Cold Shipping</div>
                                </div>
                                <div class="text-block-1035">FREE</div>
                            </div>
                        </div>
                        <div class="quarterly-details-div" style="padding-top:5px">
                            <p style="font-size: 8px;line-height: normal; padding-bottom:15px">*The clinician consultation fee is included in the program cost and is paid directly to our independent doctor network partners. This fee is processed regardless of whether you qualify for treatment or receive a prescription. If your consultation results in a denial, you will not be responsible for this payment.</p>
                            <div class="quart-deet-header-div">
                                <div class="text-block-1036">{{paymentTermLabels[paymentInfo.payment_terms].planName}}:</div>
                                <div class="div-block-1903" style="background: #00A36C;">
                                        <div class="text-block-1037" style="color:#fff" v-if="paymentInfo.payment_terms==3">Big Savings</div>
                                        <div class="text-block-1037" style="color:#fff" v-else-if="paymentInfo.payment_terms==6">Huge Savings</div>
                                        <div class="text-block-1037" style="color:#fff" v-else-if="paymentInfo.payment_terms==12">Best Price</div>
                                        <div class="text-block-1037" style="color:#fff" v-else>${{getMonthlyDiscount().toFixed(0)}} Off Your 1st Month!</div>
                                    </div>
                            </div>
                            <ul role="list" class="list-5">
                                <li class="list-item-4" v-for="(point, index) in getPlanPoints" :key="`point-plan${index}`">
                                    <div class="text-block-1038">{{point.header}}</div>
                                    <div class="text-block-1039">{{point.sub_header}}</div>
                                </li>
                                
                            </ul>
                        </div>
                        <div class="couponcodediv _1 coupon new">
                            <div class="form-block-15 w-form">
                                <form id="email-form-4" name="email-form-4" data-name="Email Form 4" method="get" data-wf-page-id="674d4a5a7395cd3bb3e7f579" data-wf-element-id="34cf4a3f-1558-6b5c-91bf-7caa1f520ff6">
                                    <div class="div-block-1897 checkout">
                                        <input class="text-field-55 coupon new w-input" maxlength="256" name="field-3" data-name="Field 3" v-model="couponInput" placeholder="Coupon Code" type="text" id="field-3" required>
                                        <a href="#" @click.prevent="handleCouponSubmit()" style="color:#fff" class="button-103 new w-button">Apply</a>
                                    </div>
                                    <div class="w-form-fail" style="display: block;" v-if="couponError">
                                        <div>Invalid Coupon.</div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="text-block-90">Monthly Access. <span class="text-span-13">Cancel anytime. </span></div>
                    </div>
                </div>
                
                <div class="div-block-1284">
                    
                    <div class="w-form">
                        <form class="step-2-left-payment-form new-checkout new-mobile _2" @submit.prevent="getStripeToken()">
    
                            <div class="div-block-853 new">
                                <div class="text-block-80"><strong>Credit Card</strong></div><img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd36103790_visa.png" class="image-471"><img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd36103780_mastercard.png" class="image-471"><img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd36103794_AmEx.png" class="image-471"><img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd3610377e_discover.png" class="image-471">
                            </div>
                            <div><label for="Card-number" class="field-label-4">Card Number</label>
                                <div id="card-element" class="ns-card-element" ref="myElement"></div>
                            </div>
                            <label for="Address" class="field-label-4 new">Shipping Address</label>
                            <google-places-autocomplete :api-key="googleMapsApiKey" @address-updated="getAddressData" />
                            <label for="email" class="field-label-4">
                            <input type="checkbox" @change="differentShipping = !differentShipping"> Different Billing Address?</label>
                            <div v-if="differentShipping">
                                <label for="email" class="field-label-4">Billing Address</label>
                                <google-places-autocomplete :api-key="googleMapsApiKey" @address-updated="getAddressDataBilling" />
                            </div>
                            <button class="submit-button-3 new w-button" :disabled="submitted" style="color:#fff">
                                <span v-if="submitted"><img src="@/assets/images/submitted.svg"></span>
                                <span v-else>Buy Now and Save</span>
                            </button>
    
                            <div class="div-block-1154">
                                <input type="hidden" name="xxTrustedFormCertUrl" id="xxTrustedFormCertUrl_0" ref="trustedFormUrl" value="">
                                <div class="text-block-252">
                                    By clicking "Buy Now and Save" or checking out with Apple or Google Pay you agree to enroll in a 
                                    {{ paymentTermLabels[paymentInfo.payment_terms].duration }}
                                    program billed 
                                    {{ paymentTermLabels[paymentInfo.payment_terms].billingFrequency }}
                                    , with automatic renewal and charges until canceled. You authorize recurring payments and confirm that you have read and agree to the <a :href="`${appMainWeb}/returns`" target="_blank">Refund Policy</a>, <a :href="`${appMainWeb}/terms`" target="_blank">Terms and Conditions</a>, <a :href="`${appMainWeb}/terms`" target="_blank">Terms of Use</a>, <a :href="`${appMainWeb}/privacy`" target="_blank">Privacy Policy</a>, <a :href="`${appMainWeb}/hipaa`" target="_blank">HIPAA Notice</a>, and <a :href="`${appMainWeb}/telehealth-consent`" target="_blank">Telehealth Consent</a>, and are at least 18 years of age.
                                </div>
                            </div>
                        </form>
                        <div class="w-form-fail" style="display:block" v-if="paymentError">
                            <div>{{errorMessage}} </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="height:280px;"></div>
        <footer-section v-if="!cartError && !initilizingCart" />
    </div>
    </template>
    
    <script>
    import {
        BasisTheory
    } from "@basis-theory/basis-theory-js";
    const bt = await new BasisTheory().init(process.env.VUE_APP_BASIS, {
        elements: true
    });
    import detectMobile from '@/utils/MobileDetection.js'
    import GooglePlacesAutocomplete from '../common/GooglePlacesAutocomplete.vue'
    import blurryLoader from '../common/blurryLoader.vue'
    import FooterElement from '../common/footerElement.vue'
    import {
        mapActions,
        mapGetters
    } from 'vuex';
    
    export default {
        name: 'CheckoutComponent',
        components: {
            GooglePlacesAutocomplete,
            blurryLoader,
            'footer-section': FooterElement,
        },
        props: ['baseUrl', 'stripeKey', 'googleMapsApiKey'],
        data() {
            return {
                paymentAttempts: 0,
                maxPaymentAttempts: 3,
                appName: process.env.VUE_APP_COMPANY,
                appMainWeb: process.env.VUE_APP_HOMEPAGE,
                payment_open: 0,
                paymentError: false,
                initilizingCart: true,
                ip_address:'',
                cartError: false,
                isApplePaySupported: false,
                isGooglePaySupported: false,
                differentShipping: false,
                couponValid: true,
                couponError: false,
                submitted: false,
                addressError: false,
                trustUrl:'',
                couponInput: '',
                message: '',
                offer: '',
                customerInfo: {
                    id: '',
                    addressLine1: '',
                    addressLine2: '',
                    city: '',
                    state: '',
                    zip: ''
                },
                billingAddress: {
                    id: '',
                    addressLine1: '',
                    addressLine2: '',
                    city: '',
                    state: '',
                    zip: ''
                },
                paymentInfo: {
                    payment_terms: 6,
                    user_id: '',
                    cardToken: '',
                    cardBrand:'',
                    amount: 443.97,
                    discount: 0,
                    medication: '',
                    couponCode: '',
                    drug_mode: '',
                    couponId: null,
                    paymentMethod: null,
                    cartItems: [],
                    cardDetails: [],
                    planId: '',
                    // Card info from Basis Theory
                    cardBin: '',
                    cardLast4: '',
                },
                pricingConfig: {
                    semaglutide: {
                        monthly: {
                            first: 205.99,
                            regular: 205.99
                        },
                        terms: {
                            3: 443.97,
                            6: 743.94,
                            12: 1187.88
                        }
                    },
                    tirzepatide: {
                        monthly: {
                            first: 274.99,
                            regular: 274.99
                        },
                        terms: {
                            3: 641.97,
                            6: 1163.94,
                            12: 2051.88
                        }
                    }
                },
                // Centralized labels for payment terms - easier to maintain
                paymentTermLabels: {
                    1: {
                        planName: "Monthly Plan",
                        duration: "monthly",
                        billingFrequency: "monthly",
                        billingLabel: "Billed Monthly",
                        supplyDuration: "Monthly"
                    },
                    3: {
                        planName: "Quarterly Plan",
                        duration: "3-month",
                        billingFrequency: "quarterly",
                        billingLabel: "Billed Quarterly",
                        supplyDuration: "3 Month"
                    },
                    6: {
                        planName: "Half yearly Plan",
                        duration: "6-month",
                        billingFrequency: "every 6 months",
                        billingLabel: "Billed Every 6 Months",
                        supplyDuration: "6 Month"
                    },
                    12: {
                        planName: "yearly Plan",
                        duration: "12-month",
                        billingFrequency: "annually",
                        billingLabel: "Billed Annually",
                        supplyDuration: "12 Month"
                    }
                }
            }
        },
    
        async mounted() {
            await this.checkAuthAndInitialize();
            this.getIpAddress();
        },
        created() { 
           
        },
        watch: {
            isMobile: {
                immediate: true,
                handler(newVal) {
                    console.log('Mobile view:', newVal);
                }
            },
            'paymentInfo.payment_terms'() {
                this.couponInput = "";
                this.paymentInfo.couponId = null;
                this.couponApplied = false;
                this.paymentInfo.discount = 0;
            }
        },
        methods: {
            ...mapActions([
                'setCartVisibility',
                'clearCart'
            ]),
            
            async getIpAddress() {
                try {
                    const response = await fetch('https://api.ipify.org?format=json');
                    const data = await response.json();
                    this.ip_address = data.ip;
                    return data.ip;
                } catch (error) {
                    console.error('Error getting IP:', error);
                }
            },

            fireTrackingEvent() {
                return new Promise((resolve) => {
                    const maxAttempts = 10; // Try for up to 2 seconds
                    let attempts = 0;

                    const attemptTracking = () => {
                        try {
                            if (window.tracking) {
                                console.log('Tracking script found, firing add_to_cart event');
                                window.tracking.event('add_to_cart', {});
                                // Wait 500ms for the pixel to fire before proceeding
                                setTimeout(resolve, 500);
                            } else {
                                attempts++;
                                if (attempts < maxAttempts) {
                                    console.log(`Waiting for tracking script... attempt ${attempts}/${maxAttempts}`);
                                    setTimeout(attemptTracking, 200); // Retry every 200ms
                                } else {
                                    console.log('Tracking script not available after waiting');
                                    resolve();
                                }
                            }
                        } catch (error) {
                            console.log('Tracking error:', error);
                            resolve();
                        }
                    };

                    attemptTracking();
                });
            },

            // PRICING METHODS - Centralized pricing logic for easier maintenance
            getProductPricing() {
                return this.getcartItems.name === 'Semaglutide' 
                    ? this.pricingConfig.semaglutide 
                    : this.pricingConfig.tirzepatide;
            },
            
            getFirstMonthPrice() {
                return this.getProductPricing().monthly.first;
            },
            
            getRegularMonthlyPrice() {
                return this.getProductPricing().monthly.regular;
            },
            
            getMonthlyDiscount() {
                return this.getRegularMonthlyPrice() - this.getFirstMonthPrice() + parseInt(this.paymentInfo.discount || 0);
            },
            
            getTotalPrice(term) {
                return this.getProductPricing().terms[term];
            },
            
            getMonthlyPrice(term) {
                return this.getTotalPrice(term) / term;
            },
            
            getCurrentPrice() {
                if (this.paymentInfo.payment_terms === 1) {
                    return this.getFirstMonthPrice();
                } else {
                    return this.getTotalPrice(this.paymentInfo.payment_terms);
                }
            },            
            showChatWindow() {
                this.$emit("showChatWindow");
            },
            
            async handleCouponSubmit() {
                this.errorMessage = null;
                if (!this.couponInput) {
                    this.errorMessage = 'Please enter a coupon code';
                    return;
                }
                this.paymentInfo.couponCode = this.couponInput;
                await this.validateCoupon();
            },
    
            async validateCoupon() {
                if (this.couponApplied) return;
                this.couponError = false;
                try {
                    const response = await this.$axios.post(`${this.baseUrl}/api/validate-coupon`, {
                        coupon: this.paymentInfo.couponCode,
                        payment_terms: this.paymentInfo.payment_terms
                    });
    
                    if (response.data.status === 'success') {
                        this.couponValid = true;
                        this.couponApplied = true;
                        this.paymentInfo.couponId = response.data.coupon_id;
                        this.paymentInfo.discount = response.data.c_val;
                    } else {
                        this.couponValid = false;
                        this.couponError = true;
                    }
                } catch (error) {
                    this.couponValid = false;
                    this.couponError = true;
                }
            },
            
            checkAuthAndInitialize() {
                if (!this.isLoggedin) {
                    this.$axios.get(`${this.baseUrl}/api/get-cart/${this.$route.params.cart_id}`, {
                            headers: {
                                'Content-Type': 'application/json',
                            }
                        }).then(response => {
                            if (response.data.status === 'success') {
                                let cartItem = response.data.cartItem;
                                try {
                                    let keyToDelete = "sema_offer";
                                    if (Object.prototype.hasOwnProperty.call(cartItem, keyToDelete)) {
                                        this.$store.dispatch('addSemaOffer', cartItem[keyToDelete]);
                                        delete cartItem[keyToDelete];
                                    }
                                    keyToDelete = "tir_offer";
                                    if (Object.prototype.hasOwnProperty.call(cartItem, keyToDelete)) {
                                        this.$store.dispatch('addTirOffer', cartItem[keyToDelete]);
                                        delete cartItem[keyToDelete];
                                    }
                                } catch (error) {
                                    console.log(error.message)
                                }
    
                                this.$store.dispatch("doLogin", response.data.userData);
                                this.$store.dispatch('addToCart', cartItem);
                                this.setCartVisibility(false);

                                // Fire tracking event before reload
                                this.fireTrackingEvent().then(() => {
                                    window.location.reload();
                                });

                            } else {
                                this.initilizingCart = false;
                                this.message = response.data.message;
                                this.cartError = true;
                                console.error("Unexpected response:", response.data);
                            }
                        })
                        .catch(error => {
                            console.error("Error saving cart:", error);
                            this.initilizingCart = false;
                            this.message = `${error.message}. Please check the checkout link is correct.`
                            this.cartError = true;
                        });
                } else {
                    this.initilizingCart = false;
                    this.$nextTick(() => {
                        this.createCardElement();
                    });
                    // Fire tracking event for logged-in users
                    this.fireTrackingEvent();
                }
            },
            
            openPaymentMethod(val) {
                if (val == this.payment_open) {
                    this.payment_open = 0;
                } else {
                    this.payment_open = val;
                }
            },
            
            changePaymentTerms(value) {
                this.paymentInfo.payment_terms = value;
            },
            
            createCardElement() {
                this.cardElement = bt.createElement('card');
                this.cardElement.mount('#card-element');
                this.cardElement.on("change", (event) => {
                    if (event.cardBrand) {
                        this.paymentInfo.cardBrand = event.cardBrand;
                    }
                    // Capture BIN (first 6-8 digits) - backend will do the lookup
                    if (event.cardBin && event.cardBin.length >= 6) {
                        this.paymentInfo.cardBin = event.cardBin;
                    }
                    // Capture last 4 digits
                    if (event.cardLast4) {
                        this.paymentInfo.cardLast4 = event.cardLast4;
                    }
                });
            },
            isPOBox(address) {
                const normalized = address.toLowerCase().replace(/\./g, '').replace(/\s+/g, ' ');
                const poBoxRegex = /\b(po box|post office box|p o box)\b(?:\s*\d{0,6})?/i;
                return poBoxRegex.test(normalized);
            },
            getAddressData(address) {
                if(this.isPOBox(address.street)){
                    this.addressError= true;
                    this.customerInfo.addressLine2 = address.address_line2;
                    this.customerInfo.city = address.city;
                    this.customerInfo.state = address.state;
                    this.customerInfo.zip = address.zip;
                }else{
                    this.addressError= false;
                    this.customerInfo.addressLine1 = address.street;
                    this.customerInfo.addressLine2 = address.address_line2;
                    this.customerInfo.city = address.city;
                    this.customerInfo.state = address.state;
                    this.customerInfo.zip = address.zip;
                    this.updateAddress();
                }
            },
            
            getAddressDataBilling(address) {
                this.billingAddress.addressLine1 = address.street;
                this.billingAddress.addressLine2 = address.address_line2;
                this.billingAddress.city = address.city;
                this.billingAddress.state = address.state;
                this.billingAddress.zip = address.zip;
            },
            
            async updateAddress() {
                try {
                    this.customerInfo.id = this.user.id;
                    this.$store.dispatch("saveShippingAddress",  this.customerInfo);
                    await this.$axios.post(`${this.baseUrl}/api/save-address`, this.customerInfo);
                } catch (error) {
                    console.error('Error updating address:', error);
                    throw new Error('Failed to update address');
                }
            },
            
            validateAddress(address) {
                return address.addressLine1 && 
                       address.city && 
                       address.state && 
                       address.zip;
            },
            
            getStripeToken() {
                this.submitted = true;
                this.paymentError = false;
                if (!this.validateAddress(this.customerInfo)) {
                    this.paymentError = true;
                    this.errorMessage = "Please enter a complete shipping address.";
                    this.submitted = false;
                    return false;
                }
                if (this.differentShipping && !this.validateAddress(this.billingAddress)) {
                    this.paymentError = true;
                    this.errorMessage = "Please enter a complete billing address.";
                    this.submitted = false;
                    return false;
                }
                this.errorReason = false;
                console.log("getting token")
                bt.tokens
                    .create({
                        type: "card",
                        data: this.cardElement,
                    })
                    .then((token) => {
                        this.paymentInfo.cardToken = token.id;
                        // Merge BIN info into cardDetails
                        this.paymentInfo.cardDetails = {
                            ...token.data,
                            cardBin: this.paymentInfo.cardBin,
                            cardBrand: this.paymentInfo.cardBrand,
                            cardLast4: this.paymentInfo.cardLast4
                        };
                        this.paymentInfo.paymentMethod = 'card';
                        console.log("calling payment")
                        this.processPayment();
                    })
                    .catch((error) => {
                        console.log("error in bt payment")
                        console.log(error);
                        this.paymentError = true;
                        this.errorMessage = "Invalid card details";
                        this.submitted = false;
                    });
            },
            
            async sendRequest(paymentData) {
                console.log("getting response")
                let response = await this.$axios.post(`${this.baseUrl}/api/checkout-new`, paymentData)
                return response;
            },
            
            async processPayment() {
                try {
                    this.trustUrl = this.$refs.trustedFormUrl.value;
                } catch (error) {
                    console.log("no trust form found")
                }

                try {
                    this.submitted = true;
                    this.paymentError = false;
                    this.paymentInfo.user_id = this.user.id;
                    this.paymentInfo.id = this.user.id;

                    // Build cart items with required pricing fields
                    const currentPrice = this.getCurrentPrice();
                    const retailPrice = this.paymentInfo.payment_terms === 1
                        ? this.getRegularMonthlyPrice()
                        : this.getFirstMonthPrice() + (this.getRegularMonthlyPrice() * (this.paymentInfo.payment_terms - 1));

                    this.paymentInfo.cartItems = this.cartItems.map(item => ({
                        ...item,
                        quantity: 1,
                        price: currentPrice,
                        retail_price: retailPrice
                    }));

                    // Calculate totals based on the pricing
                    const calculatedCartTotal = currentPrice;
                    const calculatedCartTotalNoDiscount = retailPrice;

                    this.paymentInfo.planId = this.getOfferName;
                    let paymentData = {
                        ...this.paymentInfo,
                        amount: this.amountInCents,
                        cartTotal: calculatedCartTotal,
                        cartTotalNoDiscount: calculatedCartTotalNoDiscount,
                        offer: this.offer,
                        billingAddress: this.customerInfo,
                        shippingAddress: this.customerInfo,
                        user_agent : window.navigator.userAgent,
                        ip_address : this.ip_address,
                        tracking_session_id: window.trackingSessionId
                    };

                    if (this.differentShipping) {
                        paymentData = {
                            ...this.paymentInfo,
                            billingAddress: this.billingAddress,
                            shippingAddress: this.customerInfo,
                            amount: this.amountInCents,
                            cartTotal: calculatedCartTotal,
                            cartTotalNoDiscount: calculatedCartTotalNoDiscount,
                            offer: this.offer,
                        };
                    }
                    
                    const response = await this.sendRequest(paymentData);
                    let amountCharged = ((paymentData.amount/100)-paymentData.discount)
                    if (response.data.status === 'success') {
                        await this.updateAddress();
                        await this.clearCart();
                        let transactionIdentifier;
                        try{
                            if (response.data.transaction_id) {
                                transactionIdentifier = response.data.transaction_id;
                            } else if (response.data.prescriptionPreauths && response.data.prescriptionPreauths.length > 0) {
                                transactionIdentifier = response.data.prescriptionPreauths[0].transactionId;
                            } else {
                                // Final fallback: customer ID + timestamp for unique identifier
                                transactionIdentifier = `${response.data.customerId}_${Date.now()}`;
                            }
                        }catch(e){
                            console.log(e)
                            transactionIdentifier = `${Date.now()}`;
                        }
                        
                        //await this.saveTrustFrom(this.trustUrl);
                        this.pushToRoute(amountCharged, transactionIdentifier);
                        await this.$store.dispatch('setPrescriptionPreauths', response.data.prescriptionPreauths);
                        this.submitted = false;
                    } else {
                        this.paymentError = true;
                        this.errorMessage = "Uh oh! It looks like your card was declined. No worries—your bank might have sent you a text to approve the charge. Just reply to their message to approve it and try again, or feel free to use a different card.";
                        this.submitted = false;
                    }
                } catch (error) {
                        console.log("payment error")
                        console.log(error)
                        this.paymentError = true;
                        const errorMessage = error.response?.data?.message || "";
                        
                        // Check for blocking message from backend
                        if (errorMessage.toLowerCase().includes("3 attempts") || errorMessage.toLowerCase().includes("unable to process your card after")) {
                            this.errorMessage = errorMessage; // Use the exact backend message
                            this.submitted = false;
                            return;
                        }
                        
                        // Increment payment attempts
                        this.paymentAttempts++;
                        
                        // Check if frontend has exceeded max attempts
                        if (this.paymentAttempts >= this.maxPaymentAttempts) {
                            this.errorMessage = `You've tried this card multiple times without success. Please use a different card to complete your purchase. Error: ${errorMessage}`;
                            this.submitted = false;
                            return;
                        }
                        
                        // Check for specific error cases
                        if (errorMessage === "An active order exists on your account. Please login to your account to view or modify it.") {
                            this.errorMessage = errorMessage;
                        } else if (errorMessage.toLowerCase().includes("insufficient")) {
                            this.errorMessage = "It looks like your card has insufficient funds. Please use a different payment method or contact your bank for assistance.";
                        } else if (errorMessage.toLowerCase().includes("cvv") || errorMessage.toLowerCase().includes("security code")) {
                            this.errorMessage = "The CVV/security code you entered doesn't match your card. Please double-check the 3-4 digit code on the back of your card and try again.";
                        } else if (errorMessage.toLowerCase().includes("avs") || errorMessage.toLowerCase().includes("address") || errorMessage.toLowerCase().includes("billing")) {
                            this.errorMessage = "The billing address you entered doesn't match what your bank has on file. Please verify your address details and try again.";
                        } else {
                            // Default decline message
                            this.errorMessage = "Uh oh! It looks like your card was declined. No worries—your bank might have sent you a text to approve the charge. Just reply to their message to approve it and try again, or feel free to use a different card.";
                        }
                        this.submitted = false;
                    }
            },
            
            saveTrustFrom(url) {
                try {
                    this.$axios.post(`${this.baseUrl}/api/trust-form`, { "user_id": this.user.id, "url": url });
                } catch(error) {
                    console.log("error saving url trust");
                }
            },
            blockCart(){
                this.$axios.get(`${this.baseUrl}/api/block-user-payment`);
            },
            pushToRoute(amountCharged, transaction_id) {
                try {
                    const query = {};
                    if (this.paymentInfo.payment_terms !== null) {
                        query.terms = String(this.paymentInfo.payment_terms);
                    }
                    query.amount = amountCharged;  
                    query.trans_id = transaction_id;
                    this.$router.push({
                        name: 'prescriptionThanks',
                        query
                    });
                } catch (error) {
                    console.log(error);
                    this.$router.push({
                        name: 'prescriptionThanks'
                    });
                }
            },
            getSavingsText(value) {
                const monthlyPlanTotal = this.getFirstMonthPrice() + (this.getRegularMonthlyPrice() * (value - 1));
                const prepaidTotal = this.getTotalPrice(value);
                const savings = monthlyPlanTotal - prepaidTotal;
                return `$${savings.toFixed(0)} Total Savings`
            },
        },
        
        computed: {
            ...mapGetters([
                'user',
                'cartItems',
                'cartTotal',
                'cartDiscount',
                'cartTotalNoDiscount'
            ]),
            
            
            // Get plan descriptions based on selected payment term
            getPlanPoints() {
                if (this.paymentInfo.payment_terms >= 3) {
                    // Calculate correct savings for multi-month plans
                    // First month is discounted, remaining months are at regular price
                    const monthlyPlanTotal = this.getFirstMonthPrice() + (this.getRegularMonthlyPrice() * (this.paymentInfo.payment_terms - 1));
                    const prepaidTotal = this.getTotalPrice(this.paymentInfo.payment_terms);
                    const savings = monthlyPlanTotal - prepaidTotal;
                    const savingsPercent = ((savings / monthlyPlanTotal) * 100).toFixed(0);
                    
                    return [
                        {
                            "header": `$${(savings / this.paymentInfo.payment_terms).toFixed(0)} a month savings!`,
                            "sub_header": `You will save $${(savings / this.paymentInfo.payment_terms).toFixed(0)} a month paying for ${this.paymentInfo.payment_terms} months up front ($${savings.toFixed(0)} Total Savings) vs. our monthly installment plan.`
                        },
                        {
                            "header": `Save up to ${savingsPercent}%`,
                            "sub_header": `You will save big by paying for our ${this.paymentInfo.payment_terms} month program up front.`
                        }
                    ];
                }
                
                // Monthly plan points remain unchanged
                return [{
                        "header": `$${this.getFirstMonthPrice() - this.paymentInfo.discount} for the First Month`,
                        "sub_header": "This amount applies only to the first month, providing an upfront discount to new customers."
                    },
                    {
                        "header": `$${this.getRegularMonthlyPrice()} per month thereafter`,
                        "sub_header": `After the first month, the customer will be charged the regular price of $${this.getRegularMonthlyPrice()} monthly.`
                    },
                    {
                        "header": "3 Month Supply Program",
                        "sub_header": "You'll receive a 3-month supply of medication, billed monthly. If you cancel before completing the full term, an early termination fee of $279.97 will apply."
                    }
                ];
            },
            
            getOfferName() {
                let offer = this.$store.getters.offerTir;
                if (this.getcartItems.name === 'Semaglutide') {
                    offer = this.$store.getters.offerSema;
                }
                return offer;
            },
            
            getSupplyDuration() {
                return this.paymentTermLabels[this.paymentInfo.payment_terms].supplyDuration;
            },
            
            getImage() {
                return this.getcartItems.image;
            },
            
            getcartItems() {
                return this.cartItems[0];
            },
            
            isMobile() {
                return detectMobile();
            },
            
            isLoggedin() {
                return this.$store.getters.isAuthenticated;
            },
            
            amountInCents() {
                return Math.round(this.getCurrentPrice() * 100);
            },
            
            finalTotal() {
                if (this.couponApplied) {
                    return this.cartTotalNoDiscount - this.paymentInfo.discount;
                }
                return this.cartTotal;
            },
            
            getDiscount() {
                if (this.couponApplied) {
                    return this.paymentInfo.discount;
                }
                return this.cartDiscount;
            }
        }
    }
</script>
    
    
<style>
.plan-choices-div._6month {
    border-width: 4px;
    border-color: var(--greenbutton-dark);
}
.planactive {
    background-color: var(--light-green);
    color: var(--text-color-button) !important;
}

.plan-link.quart:focus {
    background-color: var(--light-green);
}

.planactive .plan-type-text {
    color: var(--text-color-button) !important;
}

.planactive .plan-price {
    color: var(--text-color-button) !important;
}

.express-element-container {
    display: flex;
    justify-content: center;
    /* Center the buttons horizontally */
    align-items: center;
    /* Align buttons vertically */
    gap: 10px;
    /* Space between buttons */
    width: 100%;
}

.express-right-button,
.express-left-button {
    display: inline-block;
    width: auto;
    /* Default width for both buttons */
}

.express-element-container.single-button .express-right-button,
.express-element-container.single-button .express-left-button {
    width: 75%;
    /* 75% width for a single button on larger screens */
}

@media (max-width: 768px) {

    /* Target mobile devices */
    .express-element-container {
        flex-direction: column;
        /* Stack buttons vertically */
        gap: 15px;
    }

    .express-right-button,
    .express-left-button {
        width: 100%;
        /* 100% width for all buttons on mobile */
    }

    .express-element-container.single-button .express-right-button,
    .express-element-container.single-button .express-left-button {
        width: 100%;
        /* Single button takes full width on mobile */
    }
}

.checkout-product-div {
    background-color: #c9e8ff;
    background-image: none;
}

.google-pay-button-container {
    height: 48px !important;
}

.google-pay-button {
    height: 48px !important;
}

.div-block-1154-centered {
    flex-flow: column;
    justify-content: center;
    align-items: center;
    display: flex;
    padding-left: 10px;
}

.image-31-desk {
    margin-top: 15px;
    width: auto;
    height: 22px;
    margin-bottom: 0;
}
.submit-button-3.new:hover {
  background-color: rgb(0, 163, 108);
}
.button-103.new {
    background-color: var(--light-green);
}
.plan-savings-text {
    color: #fff;
}
.save-more-div {
    flex-flow: column;
    justify-content: center;
    align-items: center;
    margin-top: -20px;
    margin-bottom: -5px;
    display: flex;
    position: relative;
}
.save-more-text {
    background-color: var(--light-green);
    font-family: var(--mulish);
    color: var(--black);
    text-align: center;
    border: 1px solid #000;
    border-radius: 99px;
    padding: 3px 10px;
    font-weight: 900;
    z-index: 1;
}
.text-block-1300 {
    font-family: var(--mulish);
    color: var(--black);
    margin-bottom: 20px;
    font-size: 16px;
    line-height: 22px;
    
}
.text-span-290 {
    font-weight: 900;
}
.select-plan-text{
    margin-bottom: 1px;
}

</style>